module.exports = __webpack_public_path__ + "img/case_6.7cec7e2e.svg";